<template>
  <Modal
    :show="show"
    :title="'New Version Available'"
    :width="'420px'"
    :persistent="true"
    :closeWithEscapeKey="false"
  >
    <template #modal-main>
      <div class="new-version-body">
        <p class="new-version-text"><strong>Frontend Version:</strong> {{ version.frontend || '-' }}</p>
        <p class="new-version-text"><strong>Backend Version:</strong> {{ version.backend || '-' }}</p>
        <p class="new-version-message">New Version is available. Press OK to reload the screen.</p>
      </div>
    </template>
    <template #modal-footer>
      <div class="new-version-footer">
        <button class="button modal-action-button" @click="handleOk">
          OK
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import Modal from '@/components/Modal.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  version: {
    type: Object,
    default: () => ({ frontend: '', backend: '' }),
  },
});

const emit = defineEmits(['confirm']);

function handleOk() {
  emit('confirm');
}
</script>

<style lang="scss" scoped>
.new-version-body {
  padding: 20px;
  text-align: left;

  .new-version-text {
    margin: 0 0 6px;
    font-size: 0.78rem;
    color: #333;
  }

  .new-version-message {
    margin-top: 16px;
    padding: 12px;
    border: 1px solid var(--color-primary-200);
    border-radius: 6px;
    text-align: center;
    font-weight: 600;
  }
}

.new-version-footer {
  display: flex;
  justify-content: center;
  padding: 12px 16px;
}
</style>
